import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

import { reactive, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { ordersService } from '@/api/services/order';
import { paymentService } from '@/api/services/payment';
import { useSettingsStore } from '@/api/store/settings';

import { swanpayService } from '@/api/services/swanpay';
import { settingsService } from '@/api/services/setting';
import SwanPayContainer from '@/components/SwanPayContainer.vue';

import ND from '@/components/vectors/ND.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderPayment',
  setup(__props) {

const route = useRoute();
const router = useRouter();


const settingsStore = useSettingsStore();

const state = reactive({
    order: null as any,
    loaded: false,
    paymentData: {} as any,
    paymentSession: null as any,
    paymentInformation: "" as string,
    hasCardPayments: false,
    paymentOption: null as any
});

const getPaymentInformation = () => {
    settingsService.fetch('payment_information').then((response: any) => {
        state.paymentInformation = response.value;
    }).catch((error: any) => {
        console.log(error);
    });
}

const getOrder = () => {
    
    ordersService.show(+route.params.id).then((response) => {
        state.order = response.order;
        state.hasCardPayments = response.has_card_payments;
        state.paymentData.order_id = state.order.id;
    }).catch((error) => {
        console.log(error);
    }).finally(() => {
        
        state.loaded = true;
    });
}

const getSession = () => {
    state.paymentSession = null;

    swanpayService.getPaymentSession(state.paymentData)
        .then((response) => {
            state.paymentSession = {
                id: response.payment_session.external_session_id,
                currency: response.payment_session.currency,
                amount: response.payment_session.amount,
                sessionData: response.payment_session.session_data
            }
        })
        .catch((error) => {
            console.error(error);

            paymentError();
        })
        .finally(() => {
            state.loaded = true;
            
        });
}

const setPaymentData = (optionValue: any) => {
    state.paymentOption = null;
    state.paymentData.order_id = optionValue.order_id;
    state.paymentData.instalment_id = optionValue.instalment_id;
    state.paymentOption = optionValue;
    getSession();
}

const paymentSuccess = () => {
    state.order.status = 'processing';
    router.push({ name: 'order-confirmation', params: { id: state.order.id } });
}

const paymentError = () => {
    console.log('Payment Failed');
}

const getPaymentOptions = computed(() => {
    const options = [] as any;
    const currencySymbol = state.order.currency?.symbol ?? null;

    if (!state.order) {
        return options;
    }

    if (state.order.payment_status == "paid") {
        return options;
    }

    // Don't show instalments for supplier orders.

    if (state.order.instalments.length > 1)
    {
        state.order.instalments.forEach((instalment: any, index: number) => {
            if (instalment.payment_status == "paid" ||
                instalment.amount == 0 
            ) return;

            options.push({
                name: `instalment-${instalment.id}`,
                label: `Pay Instalment #${index+1} (${currencySymbol + instalment.price.toFixed(2)})`,
                value: { order_id: state.order.id, instalment_id: instalment.id }
            });
        });
    }

    
    options.push({
        name: "outstanding",
        label: `Pay Total Outstanding Amount (${state.order.outstanding_display})`,
        value: { order_id: state.order.id }
    });

    return options;
});

getPaymentInformation();
getOrder();

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "text-center" }, {
    default: _withCtx(() => [
      (state.order)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            class: "mt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                class: "pa-2 text-center",
                cols: "12"
              }, {
                default: _withCtx(() => [
                  (state.hasCardPayments)
                    ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, null, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                              _createElementVNode("p", { class: "p-text-lg" }, "Card Payment", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_radio_group, { row: "" }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getPaymentOptions.value, (option) => {
                                    return (_openBlock(), _createBlock(_component_v_radio, {
                                      key: option.name,
                                      label: option.label,
                                      value: option.value,
                                      onChange: ($event: any) => (setPaymentData(option.value))
                                    }, null, 8, ["label", "value", "onChange"]))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (state.paymentSession && state.paymentOption != null)
                            ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(SwanPayContainer, {
                                    session: state.paymentSession,
                                    "onPayment:success": _cache[0] || (_cache[0] = ($event: any) => (paymentSuccess())),
                                    "onPayment:error": _cache[1] || (_cache[1] = ($event: any) => (paymentError()))
                                  }, null, 8, ["session"])
                                ]),
                                _: 1
                              }))
                            : (!state.paymentSession && state.paymentOption)
                              ? (_openBlock(), _createBlock(_component_v_card_text, {
                                  key: 1,
                                  class: "text-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_progress_circular, {
                                      indeterminate: "",
                                      color: "primary"
                                    }),
                                    _cache[3] || (_cache[3] = _createElementVNode("p", null, "Loading Payment Session...", -1))
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_card, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                              _createElementVNode("p", null, "Card payments are not enabled.", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })),
                  (state.paymentInformation !== '')
                    ? (_openBlock(), _createBlock(_component_v_card, { key: 2 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, null, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                              _createElementVNode("p", { class: "p-text-lg" }, "Payment Information", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _createElementVNode("p", null, _toDisplayString(state.paymentInformation), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "text-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    color: "primary"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}
}

})